import React, { memo } from 'react';
import CommonCheckbox from '../Common/CommonCheckbox';
import './TermsAndPolicy.scss';

const TermsAndPolicy = (props = {}) => {
    const { onChange = () => { }, chatCheckBox = false } = props;
    return (
        <div className='Policy_container'>
            <CommonCheckbox
                id="agree_terms"
                name="chatCheckBox"
                checkVal={chatCheckBox}
                onChange={onChange}
            />
            <p className='Policy'>
                By continuing, you're agreeing to MirrorFly's
                <a href="https://www.mirrorfly.com/terms-and-conditions.php" target="_blank" rel="noopener noreferrer"> Terms of service </a> and
                <a href="https://www.mirrorfly.com/privacy-policy.php" target="_blank" rel="noopener noreferrer"> Privacy policy. </a>
                Consent includes receiving marketing information from MirrorFly.
            </p>
        </div>
    );
};

export default memo(TermsAndPolicy);
